module.exports = __webpack_public_path__ + "static/media/pov_north_pole_whole_Dodecahedron.9769159f.png";